import { useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import { useMilesPoints } from "../../../hooks/useMilesPoints";
import { enqueueSnackbar } from "notistack";

function PointsDeleteRewardModal({ open, setOpen, reward, callback }) {
  const { deleteReward } = useMilesPoints();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    await deleteReward({
      setLoading,
      id: reward._id,
      callback: () => {
        setOpen(false);
        callback?.(reward);
        enqueueSnackbar("Reward deleted successfully", { variant: "success" });
      },
    });
  };

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-2 py-6"
      title={"Delete reward"}
      childClassname="max-w-[90vw] lg:max-w-[660px]"
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 w-full rounded-md">
              <div className="w-full flex flex-col gap-2">
                <p className="mb-4">
                  Are you sure you want to{" "}
                  <strong className="text-black font-semibold">Delete</strong>{" "}
                  this reward?
                </p>
                <div className="flex flex-col w-full gap-3">
                  <div className="w-full gap-2 flex">
                    <button
                      className="h-12 flex items-center justify-center w-1/4 font-semibold text-sm"
                      onClick={handleClose}
                    >
                      Close
                    </button>
                    <button
                      className="h-12 flex items-center justify-center font-semibold text-sm bg-red-600 text-white flex-1 rounded-md"
                      disabled={loading}
                      onClick={() => handleDelete()}
                    >
                      {loading ? (
                        <div className="buttonLoader"></div>
                      ) : (
                        <>Delete</>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default PointsDeleteRewardModal;
